import { isAuthRejection } from "@/shared/authFailure.ts";
import type { FetchStatus } from "@tanstack/react-query";

export type AuthGate = "loading" | "app" | "signed-out" | "unreachable";

type AuthGateInput = {
  hasUser: boolean;
  isPending: boolean;
  fetchStatus: FetchStatus;
  error: unknown;
};

export function resolveAuthGate({
  hasUser,
  isPending,
  fetchStatus,
  error,
}: AuthGateInput): AuthGate {
  if (hasUser) return "app";
  if (fetchStatus === "paused") return "unreachable";
  if (isPending) return "loading";
  if (error === null || error === undefined) return "signed-out";
  return isAuthRejection(error) ? "signed-out" : "unreachable";
}
